import { Pipe, PipeTransform } from "@angular/core";
import { beautifyCamelCaseString } from "src/app/common/stringUtils";

@Pipe({
    name: "beautifyDisplayString",
    standalone: true,
})
export class BeautifyDisplayStringPipe implements PipeTransform {
    /**
     * A pipe to beautify displayed snake_case or camelCase strings in UI
     * For single words it capitalizes first letter: vulnERAbility -> Vulnerability
     * For concatenated words with "_": data_flow -> Data Flow
     * For camelCase words: dataFlow -> Data Flow
     * For PascalCase words: DataFlow -> Data Flow
     */

    public transform(value?: string | null): string {
        if (!value) {
            return "";
        }

        if (value.startsWith("ZN_")) {
            return value;
        }

        let splitted = value.split("_");

        // snake_case (assumes underscore means snake_case)
        if (splitted.length > 1) {
            splitted = splitted.map((item) => this._capitalizeInternal(item));
            return splitted.join(" ");
        }

        // camelCase (assumes first letter lower case means camelCase)
        if (value.charAt(0) === value.charAt(0).toLowerCase()) {
            return beautifyCamelCaseString(value);
        }

        // PascalCase
        if (value.charAt(0) === value.charAt(0).toUpperCase()) {
            return value.replace(/([a-z])([A-Z])/g, "$1 $2");
        }

        return value;
    }

    private _capitalizeInternal(value: string): string {
        let capitalizedString = "";
        if (value.length === 1) {
            capitalizedString = value.charAt(0).toUpperCase();
        } else {
            const lowerValue = value.toLowerCase();
            capitalizedString = lowerValue.charAt(0).toUpperCase() + lowerValue.slice(1);
        }
        return capitalizedString;
    }
}
